import { useTranslation } from "react-i18next";

const DOCS_DOMAIN = 'docs.billion.live';

const supportList = {
  qA: `https://${DOCS_DOMAIN}/`,
  liveStream: `https://${DOCS_DOMAIN}/live-streaming`,
  liveCheck: `https://${DOCS_DOMAIN}/live-streaming/zhu-bo-obs-kai-bo-qian-zi-jian-shou-ce-v1.0`
};

const supportListEs = {
  qA: `https://${DOCS_DOMAIN}/qa-documentation-en`,
  liveStream: `https://${DOCS_DOMAIN}/live-streaming/live-streaming-support-obs-webrtc`,
  liveCheck: `https://${DOCS_DOMAIN}/live-streaming/obs-pre-stream-self-check-guide-for-streamers-v1.0`
};


export const useSupport = (key: keyof typeof supportList) => {
  const { t, i18n } = useTranslation();
  // 根据语言获取对应的支持列表, 只有中文走到supportList，否则都是英文
  const language = i18n.language;
  if (language === 'zh-CN') {
    return supportList[key];
  } else {
    return supportListEs[key];
  }
}